import { IconSource } from '../icon-source'

interface IProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  type: 'DOC' | 'LINK' | 'VIDEO'
  url: string
}

export function SupportArchive({ type, url }: IProps) {
  return (
    <a href={url} className="cursor-pointer">
      <div className="flex w-full py-2 px-3 my-2 items-center border-tertiary justify-between rounded-4 border rounded-md">
        <div className="flex">
          <IconSource type={type} />
          <div className="px-2">
            <p className="text-[16px]">Dominando os modulos</p>
            <p className="text-[12px] text-disabled">Mais de 1200 exercicios</p>
            <p className="text-[12px] text-disabled">12MB</p>
          </div>
        </div>
        <div style={{ width: 24 }}>
          {type === 'DOC' && <img src="/icon-download.svg" alt="icon" />}
          {type === 'LINK' && <img src="/icon-navigate.svg" alt="icon" />}
        </div>
      </div>
    </a>
  )
}
